import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { aiAssistantContext } from '../../../../state/AIAssistantContextProvider';
import {
  aiAssistantEditorContext,
  AIAssistantEditorMode,
} from '../../../../state/AIAssistantEditorProvider';
import { ActiveView } from '../constants';
import { getCurrentConversation } from '../../../../reducers/aiAssistant.selectors';
import { PodcastMessageContext } from '../podcastTypes';

// Podcast state starts with generation and persists via the message context,
// regardless of whether the detail view is open.
const useIsPodcastConversation = (): boolean => {
  const { activeView } = useContext(aiAssistantContext);
  const { mode } = useContext(aiAssistantEditorContext);
  const currentConversation = useSelector(getCurrentConversation);

  const hasPodcastMessage = Boolean(
    currentConversation?.data?.messages?.some((message) => Boolean(
      (message.context as PodcastMessageContext | undefined)?.generatedPodcastId
    ))
  );

  return hasPodcastMessage
    || mode === AIAssistantEditorMode.PODCAST
    || activeView === ActiveView.PODCAST_LOADING;
};

export default useIsPodcastConversation;
